module.exports = __webpack_public_path__ + "static/img/ES.299e47a.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/images/userTips/ES.png
// module id = M0zk
// module chunks = 1